export enum MessageTypeEnum {
  Acknowledge = 'ACKNOWLEDGE',
  OutOfService = 'OUTOFSERVICE',
  Letter = 'LETTER'
}

export enum ApplicantMessageEnum {
  Message2a = '2a',
  Message2b = '2b',
  Message2c = '2c',
  Message2d = '2d'
}
